// extracted by mini-css-extract-plugin
module.exports = {"terms":"Terms_terms__2XF-S","top":"Terms_top__jyGpJ","breadcrumb":"Terms_breadcrumb__t44Ra"};